import { helpers } from '@vuelidate/validators';
import { getByPathPriority } from './utlis/getByPathPriority';
import { diffBetweenWords } from './utlis/diffBetweenWords';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(customParseFormat);

export const onlyCyr = (value) => {
	return !/[A-Za-z0-9`~!@#№$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/ig.test(value);
}

export const noSpecSymbol = (value) => {
	return !/[`~!@#№$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/.test(value);
};

export const validDocnumber = (value) => {
	return !/[`~!@#$%^&*+;,<>]/ig.test(value);
};

export const onlyCyrSymbol = (value) => {
	return !helpers.req(value) || !/[a-z]/i.test(value);
};

/**
 * Поле может содержать до {limit} латинских букв
 * TODO оптимизировать
 * @param {number} limit
 */
export const limitLatSymbol = (limit) => helpers.withParams(
    { type: 'limit', limit },
    (val) => {
        let alphabet = 'abcdefghijklmnopqrstuvwxyz';
        let counter = 0;

        if (typeof val === 'string') {
            [...val].forEach(word => {
                if (alphabet.includes(word.toLowerCase())) {
                    counter++;
                }
            });
        }

        return !helpers.req(val) || counter < limit;
    },
);

export const onlyLatSymbol = (value) => {
	return !/[А-Яа-яЁё0-9`~!@#№$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/ig.test(value)
};

export const onlyNumbers = (value) => {
	return !/\D/.test(value);
};

export const passportIssueBy = (value) => {
	return !helpers.req(value) || !/[a-z]/i.test(value);
};

export const passportSerNum = (value) => {
	if (!value) return false;
	return value.replace(/[^0-9.]/g, '').length == 4
};

export const passportNum = (value) => {
	if (!value) return false;
	return value.replace(/[^0-9.]/g, '').length == 6
};

export const phoneLength = (value) => {
	if (!value) return false;
	return value.replace(/[^0-9.]/g, '').length >= 11
};

export const passportCode = (value) => {
	return !helpers.req(value) || value.replace(/[^0-9.]/g, '').length == 6
};

export const addressCommas = (value) => {
	return !!/,.*,.*/.test(value);
}

export const cyrWithDash = (value) => {
	return !helpers.req(value) || !(/[a-z0-9`~!@#№$%^&*()_|+=?;:'"<>{}[\]\\/]/i.test(value));
}

export const latWithDash = (value) => {
	return !(/[а-я0-9`~!@#№$%^&*()_|+=?;:'"<>{}[\]\\/]/i.test(value));
}

export const validCityName = (value) => {
	return !(/[a-z`~!@#№$%^&*()_|+=?;:'"<>{}[\]\\/]/i.test(value));
}

export const twoWords = (value) => {
	return value.split(' ').filter(val => val !== '').length >= 2;
}

export const correctPhone = (value) => {
    if (!value) return true;
    return /^7[3,4,7-9]\d{9}$/.test(value.replace(/\D/g, ''))
}

export const seemsDigitInPhone = function (value) {
	value = value.replace(/[^0-9]/g, '').substr(1);
	value = value.split('');
	var limit = 10;
	var flag = true;

	var matches = value.reduce(function(acc, el) {
		acc[el] = (acc[el] || 0) + 1;
		return acc;
	}, {});

	for (var el in matches) {
		if (matches[el] >=  limit) {
			flag = false;
		}
	}
	return flag;
}

export const correctInn = function(value) {
	value = value.replace(/\s/g, '');
	if ( value.match(/\D/) || !value ) return true;
	if (value == '0000000000' || value == '000000000000') return false;
	var inn = value.match(/(\d)/g);

	if ( inn.length == 10 ) {
		return inn[9] == String(((
			2*inn[0] + 4*inn[1] + 10*inn[2] +
			3*inn[3] + 5*inn[4] +  9*inn[5] +
			4*inn[6] + 6*inn[7] +  8*inn[8]
		) % 11) % 10);
	}
	else if ( inn.length == 12 )
	{
		return inn[10] == String(((
				7*inn[0] + 2*inn[1] + 4*inn[2] +
				10*inn[3] + 3*inn[4] + 5*inn[5] +
				9*inn[6] + 4*inn[7] + 6*inn[8] +
				8*inn[9]
		) % 11) % 10) && inn[11] == String(((
			3*inn[0] +  7*inn[1] + 2*inn[2] +
			4*inn[3] + 10*inn[4] + 3*inn[5] +
			5*inn[6] +  9*inn[7] + 4*inn[8] +
			6*inn[9] +  8*inn[10]
		) % 11) % 10);
	}

	return false;
}

// проверка на ОГРН и ОГРНИП
export const correctOgrn = function(ogrn) {
	if ( ogrn.match(/\D/) || !ogrn ) return true;
    ogrn = String(ogrn).replace(/[^0-9]+/g, '');
    if(ogrn.length == 13) {
        // ОГРН
        return ogrn[12] == (parseInt(ogrn.slice(0, -1)) % 11).toString().slice(-1);
    }
    else if(ogrn.length == 15) {
        // ОГРНИП
        return ogrn[14] == (parseInt(ogrn.slice(0, -1)) % 13).toString().slice(-1);
    }
    return false;
}

export const correctKPP = function(val) {
	if ( val.match(/\D/) || !val ) return true;
    if (val.length != 9) {
        return false
    }
    if (!val.match(/^\d{4}[\dA-Z][\dA-Z]\d{3}$/)) {
        return false;
    }
    else {
        return true;
    }
}

export const correctSnils = function (value) {
	value = value.replace(/\s/g, '');
	if (value == '00000000000' || value.length !== 11) return false;
	var checkSum = parseInt(value.slice(9),10);
	var flag = false;

	//строка как массив(для старых браузеров)
	value = "" + value;
	value = value.split('');

	var sum = (value[0]*9 + value[1]*8 + value[2]*7 + value[3]*6 + value[4]*5 + value[5]*4 + value[6]*3 + value[7]*2 + value[8]*1);

	if (sum < 100 && sum == checkSum) {
		flag = true;
	} else if ((sum == 100 || sum == 101) && checkSum == 0) {
		flag = true;
	} else if (sum > 101 && (sum%101 == checkSum || (sum%101 == 100 && checkSum == 0))) {
		flag = true;
	} else {
		flag = false;
	}
	return !helpers.req(value) || flag;
}

export const checkInnEgrul = (value) => {
	if (value.length === 0) return true;
	if (value.replace(/[0-9.]/g, '').length !== 0) return false;
	const innArray = value.split('').map(function (s) {
		return +s
	});

	switch (value.length) {
		case 10:
			return checkTenSignsInn(innArray);
		case 12:
			return checkTwelveSignsInn(innArray);
		default:
			return false;
	}
};

export const checkCodeword = (value) => {
	return !helpers.req(value) || value.length >= 6 && value.length <= 30 && noSpecSymbol(value) && onlyCyr(value);
};

export const checkDate = (formattedDate, min, max) => {
	const minDate = getDateTime(getValidationDate(min));
	const maxDate = getDateTime(getValidationDate(max));
	const value = getDateTime(formattedDate);

	return (value <= minDate && value >= maxDate);
}


function checkTenSignsInn (innArray) {
	const checksum = this.calcCheckSum(innArray, [2, 4, 10, 3, 5, 9, 4, 6, 8, 0]);
	const checkValue = this.calcCheckValue(checksum);

	return checkValue === innArray[9];
}

function checkTwelveSignsInn(innArray) {
	const checksumFirst = calcCheckSum(innArray.slice(0, 11), [7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0]);
	const checkValueFirst = calcCheckValue(checksumFirst);
	const checksumSecond = calcCheckSum(innArray, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0]);
	const checkValueSecond = calcCheckValue(checksumSecond);

	return checkValueFirst === innArray[10] && checkValueSecond === innArray[11];
}

function calcCheckSum(numbers, coefficients) {
	return numbers.reduce(function (acc, num, index) {
		return acc + num * coefficients[index];
	}, 0);
}

function calcCheckValue(checksum) {
	let result = checksum % 11;
	if (result > 9) result = result % 10;

	return result;
}

function getValidationDate(years) {
	if (!years && years !== 0) {
		return undefined;
	}

	let date = new Date();
	date.setFullYear(date.getFullYear() - years);

	return formatDate(date);
}

function getDateTime(formattedDate) {
	let delimiter = formattedDate.indexOf('-') < 0 ? '.' : '-';
	let dateParts = formattedDate.split(delimiter);
	let day = +dateParts[0], month = +dateParts[1] - 1, year = +dateParts[2];

	if (delimiter === '-') {
		day = +dateParts[2];
		year = +dateParts[0];
	}

	let date = new Date(year, month, day);

	return date.getTime();
}

function formatDate(date) {
	let day = +date.getDate(), month = +date.getMonth() + 1, year = +date.getFullYear();

	return [day, month, year].join('.');
}

/**
 * Сравнивает с референсным значением, можно указать кол-во символов на которое допустимо различие
 *  ФУНКЦИЯ ЗАВИСИТ ОТ КОНТЕКСТА!!!
 *
 * @param {number} [num=0] - кол-во символов на которое допустимо различие
 * @param {string} equalTo - путь к значению с которым сравниваем, относительно экземпляра компонента
 * @this Object - экземпляр компонента
 */
export function diffBetweenWordsLessThan (equalTo, num = 0) { return helpers.withParams(
    { type: 'cardnameCheck', equalTo, num },
    function(value) {
        return diffBetweenWords(value, getByPathPriority(this, [equalTo])) <= num;
    }
)}

/**
 * Минимальное количество лет
 * @param {number} [min=0] - мин. кол-во лет
 * @param {string} val - дата в формате DD.MM.YYYY
 */
export const ageMin = (min = 0) => helpers.withParams(
    { type: 'ageMin', min },
    (val) => {
        const valD = dayjs(val, 'DD.MM.YYYY');
        return !helpers.req(val) || !valD.isValid() || valD.add(min, 'year').isSameOrBefore(dayjs(), 'day');
    },
);

/**
 * Максимальное количество лет
 * @param {number} [max=150] - макс. кол-во лет
 * @param {string} val - дата в формате DD.MM.YYYY
 */
export const ageMax = (max = 150) => helpers.withParams(
    { type: 'ageMax', max },
    (val) => {
        const valD = dayjs(val, 'DD.MM.YYYY');
        return !helpers.req(val) || !valD.isValid() || valD.add(max, 'year').isSameOrAfter(dayjs(), 'day');
    },
);

/**
 * Минимальная дата
 * @param {string} date дата в формате DD.MM.YYYY
 * @param {string} val - дата в формате DD.MM.YYYY
 */
export const minDate = (date) => helpers.withParams(
    { type: 'minDate', date },
    (val) => {
        const valD = dayjs(val, 'DD.MM.YYYY');
        const minD = dayjs(date, 'DD.MM.YYYY');
        return !helpers.req(val) || !valD.isValid() || !valD.isBefore(minD, 'day');
    },
);

/**
 * Максимальная дата
 * @param {string} date дата в формате DD.MM.YYYY
 * @param {string} val - дата в формате DD.MM.YYYY
 */
export const maxDate = (date) => helpers.withParams(
    { type: 'maxDate', date },
    (val) => {
        const valD = dayjs(val, 'DD.MM.YYYY');
        const maxD = dayjs(date, 'DD.MM.YYYY');
        return !helpers.req(val) || !valD.isValid() || !valD.isAfter(maxD, 'day');
    },
);
